
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import selectTime from "@/components/select-time/select-time.vue";
import { objAny } from "@/common/common-interface";
import { getOperateLoginLog } from "@/api/api-operatelog";
import i18n from "@/config/i18n";
@Component({
  components: {
    "select-time": selectTime
  }
})
export default class SystemConfigLog extends Vue {
  @Prop({ default: "" }) private tabName!: string;
  @Prop({ default: "" }) private activeTab!: string;
  private total = 0;
  private loading = false;
  private formInline: objAny = {
    startTime: "",
    endTime: "",
    globalPageIndex: 1,
    globalPageSize: 10,
    globalSearch: "",
    type: ""
  };
  private ruleInline = {};
  private tableList: object[] = [];
  private tableColumns: object[] = [
    {
      title: i18n.t("user.userName"),
      key: "userName",
      minWidth: 80
    },
    {
      title: i18n.t("log.loginIp"),
      key: "loginIp",
      sortable: true,
      minWidth: 120
    },
    {
      title: i18n.t("log.loginTime"),
      key: "loginTime",
      minWidth: 160
    },
    {
      title: i18n.t("log.resultDesc"),
      key: "resultDesc",
      minWidth: 200
    }
  ];

  public timeChange(data: objAny): void {
    this.formInline.startTime = data.startTime;
    this.formInline.endTime = data.endTime;
    // this.getTableList();
  }

  public queryClick(): void {
    this.formInline.globalPageIndex = 1;
    this.getTableList();
  }
  public pageChange(val: number): void {
    this.formInline.globalPageIndex = val;
    this.getTableList();
  }
  public sizeChange(val: number): void {
    this.formInline.globalPageSize = val;
    this.getTableList();
  }

  public sortChange(column: objAny): void {
    if (column.order === "normal") {
      this.formInline.globalOrder = "";
    } else {
      this.formInline.globalOrder =
        "name=" + column.key + ",age=" + column.order;
    }
    this.getTableList();
  }
  async getTableList(): Promise<void> {
    this.loading = true;
    const ret = await getOperateLoginLog(this.formInline);

    if (ret.status === this.$config.apiStatus) {
      this.total = ret.total;
      this.tableList = ret.data;
    }
    this.loading = false;
  }
  public init(newVal: string): void {
    if (newVal === this.tabName && this.tableList.length === 0) {
      this.getTableList();
    }
  }
  @Watch("activeTab")
  getVisible(newVal: string) {
    this.init(newVal);
  }
  mounted() {
    //
  }
}
